module.exports = {"rows_per_page":"Rijen per pagina","out_of_pages":"van","all":"Alle","search_data":"Zoek gegevens"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-materialize-datatable/src/locales/nl.json
// module id = Hl5r
// module chunks = 1